<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<!-- <div id="background"></div> -->
<!-- <header class="header" *ngIf="initialized && !isDxsales">
  <img src="/assets/sgzp-app2/images/logo.svg" />
</header> -->
<ng-container *ngIf="initialized && !isDxsales && !isKanri">
  <div *ngIf="page === 'login'" id="login_background">
    <div class="container" style="max-width: unset">
      <div
        data-app="true"
        class="v-application v-application--is-ltr theme--light"
        style="width: 100%; background-color: unset"
      >
        <div style="width: 100%">
          <div class="inner" style="max-width: unset">
            <img
              src="/assets/sgzp-app2/images/logo.svg"
              style="max-width: 100vw"
            />

            <div id="login_main">
              <div class="login_main_content">
                <p id="login_title">
                  {{ loginTitleText }}
                </p>

                <div class="custom-field">
                  <input required [(ngModel)]="email" id="email" type="text" />
                  <span class="placeholder">メールアドレス</span>
                </div>
                <div
                  class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
                >
                  <div class="v-input__control">
                    <div class="v-text-field__details">
                      <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                      <div class="v-messages theme--light error--text">
                        <div
                          *ngIf="errorMessages.login.email"
                          class="v-messages__wrapper"
                        >
                          {{ errorMessages.login.email }}

                          <!-- 注釈及びエラーテキストが入ります。 -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
                <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
                <div
                  class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
                >
                  <div class="v-input__control">
                    <app-sgzp-app2-password-input-animated
                      class="border-bold"
                      [(ngModel)]="password"
                      name="confirm"
                      placeholder="パスワード（再入力）"
                    ></app-sgzp-app2-password-input-animated>
                    <div class="v-text-field__details">
                      <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                      <div class="v-messages theme--light error--text">
                        <div
                          *ngIf="errorMessages.login.password"
                          class="v-messages__wrapper"
                        >
                          {{ errorMessages.login.password }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <label class="agreement d-flex align-start mt-6 mb-3">
                  <!-- TODO margin-topじゃない自動レイアウト -->
                  <div
                    style="margin-top: 5px"
                    class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox"
                    (click)="checkIsEmailSave()"
                  >
                    <div class="v-input__control">
                      <div style="height: 32px; align-items: center">
                        <div
                          class="v-input--selection-controls__input primary--text"
                        >
                          <i
                            aria-hidden="true"
                            [class]="isEmailSaveCheckedStyle.i"
                          ></i
                          ><input
                            [(ngModel)]="isSaveEmail"
                            aria-checked="true"
                            id="input-32"
                            role="checkbox"
                            type="checkbox"
                            value=""
                          />
                          <div [class]="isEmailSaveCheckedStyle.div"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="text-gray600"
                    >ログイン情報を保存する</span
                  ></label
                >

                <div class="text-center">
                  <button
                    (click)="login()"
                    type="button"
                    class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary full-width"
                    medium=""
                  >
                    <span class="v-btn__content"> ログイン </span>
                  </button>
                </div>

                <div class="mb-6" style="display: flex; flex-direction: column">
                  <div
                    class="mb-6"
                    style="
                      display: flex;
                      justify-content: start;
                      align-items: baseline;
                    "
                  >
                    <a
                      (click)="navigate('forgot-password')"
                      class="text-link text-link-underline v-text-caption"
                    >
                      パスワードをお忘れの方はこちら
                    </a>
                  </div>

                  <div style="display: flex; justify-content: center">
                    <a
                      [href]="registerUrl"
                      class="secondary-button"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <p>新規登録</p>
                    </a>
                  </div>

                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      align-items: baseline;
                    "
                  >
                    <a
                      (click)="navigate('register-resend')"
                      class="text-link text-link-underline v-text-caption"
                    >
                      認証メール再発行はこちら
                    </a>
                  </div>
                  <div class="store_link_pc" *ngIf="!isFromNativeApp">
                    <a
                      href="https://apps.apple.com/jp/app/apple-store/id6466621360"
                      target="_blank"
                    >
                      <img src="/assets/sgzp-app2/images/app_store.svg" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=jp.co.suzuken.hattyuApp"
                      target="_blank"
                    >
                      <img src="/assets/sgzp-app2/images/google_play.svg" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="login_main_content_notifications">
                <ng-container *ngIf="message">
                  <div class="mb-6"></div>
                  <!-- お知らせ -->
                  <div
                    id="notifications"
                    *ngIf="message"
                    class="item ng-star-inserted login_news ql-editor"
                  >
                    <div>
                      <!-- <div class="hogehoge">{{ message.date }}</div>
                      <div id="notification_title">{{ message.title }}</div> -->
                      <div class="hagehage">
                        <div [innerHTML]="message.message"></div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <div class="mb-3"></div>
                <div class="store_link_sp" *ngIf="!isFromNativeApp">
                  <div style="margin-right: 5px">
                    <a
                      href="https://apps.apple.com/jp/app/apple-store/id6466621360"
                      target="_blank"
                    >
                      <img
                        src="/assets/sgzp-app2/images/app_store.svg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div style="margin-left: 5px">
                    <a
                      href="https://play.google.com/store/apps/details?id=jp.co.suzuken.hattyuApp"
                      target="_blank"
                    >
                      <img
                        src="/assets/sgzp-app2/images/google_play.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="login_footer">
      <img
        src="/assets/sgzp-app2/images/suzuken_group.svg"
        style="max-width: 100vw"
      />
      <!-- 不要とのことなので一旦コメントアウト -->
      <!-- <span class="version">V1.0.0</span> -->
    </div>
  </div>

  <div *ngIf="page === 'register'">
    <div class="container">
      <div class="auto-layout">
        <app-sgzp-app2oem-register-message
          [clientId]="clientId"
          *ngIf="isOem"
        ></app-sgzp-app2oem-register-message>
        <p *ngIf="!isOem" class="v-text">
          Doctors Stationへようこそ。<br />まずはあなたのアカウントを作りましょう
        </p>
      </div>
      <div data-app="true" class="v-application--is-ltr theme--light">
        <div class="v-application--wrap">
          <div class="inner">
            <div class="name-area">
              <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
              <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
              <div
                class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
              >
                <div class="v-input__control">
                  <div
                    class="v-input__slot"
                    [ngClass]="
                      errorMessages.signup.familyName ? ['custom-error'] : []
                    "
                  >
                    <div class="v-text-field__slot v-text-body-1">
                      <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                      <label for="lastName" [class]="familyNameLabelClass"
                        >姓</label
                      >
                      <input
                        (focus)="focus(inputState.lastName)"
                        (blur)="blur(inputState.lastName)"
                        [(ngModel)]="lastName"
                        id="lastName"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                    <div class="v-messages theme--light error--text">
                      <div
                        *ngIf="errorMessages.signup.familyName"
                        class="v-messages__wrapper"
                      >
                        {{ errorMessages.signup.familyName }}
                        <!-- 注釈及びエラーテキストが入ります。 -->
                        <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
              <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
              <div
                class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
              >
                <div class="v-input__control">
                  <div
                    class="v-input__slot"
                    [ngClass]="
                      errorMessages.signup.givenName ? ['custom-error'] : []
                    "
                  >
                    <div class="v-text-field__slot v-text-body-1">
                      <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                      <label for="firstName" [class]="givennameLabelClass"
                        >名</label
                      >
                      <input
                        (focus)="focus(inputState.firstName)"
                        (blur)="blur(inputState.firstName)"
                        [(ngModel)]="firstName"
                        id="firstName"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->

                    <div class="v-messages theme--light error--text">
                      <div
                        *ngIf="errorMessages.signup.givenName"
                        class="v-messages__wrapper"
                      >
                        {{ errorMessages.signup.givenName }}
                        <!-- 注釈及びエラーテキストが入ります。 -->
                        <!-- 半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください。 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="isOem" style="margin-top: -20px; margin-bottom: 20px">
              <p class="v-text-caption">陽性者本人の姓名を入力してください</p>
            </div>

            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="errorMessages.signup.email ? ['custom-error'] : []"
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label for="email" [ngClass]="inputLabelClass" class="bold"
                      >メールアドレス</label
                    >
                    <input
                      (focus)="focus(inputState.email)"
                      (blur)="blur(inputState.email)"
                      [(ngModel)]="email"
                      id="email"
                      type="email"
                    />
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.email"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
            <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
            <div
              class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="
                    errorMessages.signup.password ? ['custom-error'] : []
                  "
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label
                      for="password"
                      [ngClass]="passwordLabelClass"
                      class="bold"
                      >パスワード</label
                    >
                    <input
                      (focus)="focus(inputState.password)"
                      (blur)="blur(inputState.password)"
                      [(ngModel)]="password"
                      id="password"
                      [type]="passwordToggle.password ? 'text' : 'password'"
                    />
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <app-mdi-eye
                        [show]="passwordToggle.password"
                        (click)="
                          passwordToggle.password = !passwordToggle.password
                        "
                      ></app-mdi-eye>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.password"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.password }}
                    </div>
                    <div *ngIf="!errorMessages.signup.password">
                      <p class="v-text-caption">
                        半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- focus時 class="v-input ..." に v-input--is-focused、primary--text を追加 ↓ -->
            <!-- エラー時 class="v-input ..." に v-input--has-state、error--text を追加 ↓ -->
            <div
              class="mb-6 v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            >
              <div class="v-input__control">
                <div
                  class="v-input__slot"
                  [ngClass]="
                    errorMessages.signup.confirmPassword ? ['custom-error'] : []
                  "
                >
                  <div class="v-text-field__slot">
                    <!-- focus時 class="v-label ..." に v-label--active、primary--text を追加 ↓ -->
                    <label
                      for="confirmationPassword"
                      [ngClass]="confirmPasswordLabelClass"
                      class="bold"
                      >パスワード（確認）</label
                    >
                    <input
                      (focus)="focus(inputState.confirmPassword)"
                      (blur)="blur(inputState.confirmPassword)"
                      id="confirmationPassword"
                      [type]="passwordToggle.confirm ? 'text' : 'password'"
                      [(ngModel)]="confirmPassword"
                    />
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <app-mdi-eye
                        [show]="passwordToggle.confirm"
                        (click)="
                          passwordToggle.confirm = !passwordToggle.confirm
                        "
                      ></app-mdi-eye>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.confirmPassword"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.confirmPassword }}
                    </div>
                    <div *ngIf="!errorMessages.signup.confirmPassword">
                      <p class="v-text-caption">
                        パスワードを確認するために再入力してください
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <label class="agreement d-flex align-start mb-6"
              ><div
                class="v-input v-input--is-focused theme--light v-input--selection-controls v-input--checkbox mb-8"
                (click)="check()"
              >
                <div class="v-input__control">
                  <div>
                    <div
                      class="v-input--selection-controls__input primary--text"
                    >
                      <i
                        aria-hidden="true"
                        [class]="checkedStyle.i"
                        class="bold"
                      ></i
                      ><input
                        aria-checked="true"
                        id="input-32"
                        role="checkbox"
                        type="checkbox"
                        value=""
                      />
                      <div [class]="checkedStyle.div"></div>
                    </div>
                  </div>
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.signup.terms"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.signup.terms }}
                    </div>
                  </div>
                </div>
              </div>
              <span
                ><a
                  [href]="termsUrl"
                  target="_blank"
                  class="text-link primary--text"
                  >利用規約</a
                >および<a
                  [href]="privacyUrl"
                  target="_blank"
                  class="text-link primary--text"
                  >プライバシーポリシー</a
                >に同意します。</span
              ></label
            >

            <div class="text-center mb-6">
              <button
                type="button"
                class="primary-button full-width v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                medium=""
                (click)="register()"
              >
                <span class="v-btn__content text-button-medium"> 登録 </span>
              </button>
            </div>

            <div
              style="
                display: flex;
                justify-content: center;
                align-items: baseline;
              "
            >
              <div class="text-center mb-6 v-text-caption">
                認証メール再発行はこちら
              </div>
              <a
                (click)="navigate('register-resend')"
                class="text-link v-text-caption"
              >
              </a>
            </div>

            <div class="divider mb-3"></div>

            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: baseline;
              "
            >
              <div class="text-center mb-6 v-text-caption">
                アカウントをお持ちの方
              </div>
              <button
                (click)="navigate('login')"
                class="btn-lighten-5 v-btn theme--dark"
              >
                <p class="v-text bold">ログイン</p>
              </button>
              <!-- <a (click)="navigate('login')" class="text-link"> ログイン </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-header></app-header>
    <div class="container isBackgoround" style="padding: 0px">
      <main>
        <div class="v-application v-application--is-ltr theme--light main">
          <form
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <h1 class="mb-10 h3">パスワードの再設定</h1>
            <p
              style="
                font-family: Noto Sans JP;
                font-size: 16px;
                font-weight: 400;
                line-height: 29px;
                letter-spacing: 0em;
                text-align: center;
                margin-bottom: 24px;
              "
            >
              パスワード再設定用ＵＲＬを発行いたします。<br />
              下記に登録したメールアドレスを入力してください。
            </p>
            <div
              class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
              style="display: flex; justify-content: center"
            >
              <div class="v-input__control common_input">
                <div style="display: flex; align-items: center">
                  <label
                    for="input-13"
                    class="bold"
                    style="height: 29px; margin-right: 12px"
                    >メールアドレス</label
                  >
                  <app-required-label></app-required-label>
                </div>
                <div class="v-input__slot">
                  <input
                    (focus)="focus(inputState.email)"
                    (blur)="blur(inputState.email)"
                    id="input-13"
                    name="input-13"
                    type="email"
                    [(ngModel)]="email"
                  />
                </div>
                <div class="v-text-field__details">
                  <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                  <div class="v-messages theme--light error--text">
                    <div
                      *ngIf="errorMessages.forgetpassword.email"
                      class="v-messages__wrapper"
                    >
                      {{ errorMessages.forgetpassword.email }}

                      <!-- 注釈及びエラーテキストが入ります。 -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- TODO アプリレイアウト -->
            <div class="text-center mb-6" style="width: 550px; max-width: 90vw">
              <button
                type="button"
                class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
                style="width: 100%"
                medium=""
                (click)="changePassword()"
              >
                <span class="v-btn__content bold"> 送信 </span>
              </button>
            </div>
            <div style="justify-content: center; display: flex">
              <a (click)="navigate('login')" class="text-link v-text-caption">
                戻る
              </a>
            </div>
          </form>
        </div>
      </main>
    </div>
  </div>
  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-sgzp-app2change-password-sent
      [clientId]="clientId"
    ></app-sgzp-app2change-password-sent>
  </div>
  <app-sgzp-app2register-resend
    *ngIf="page === 'register-resend'"
  ></app-sgzp-app2register-resend>
</ng-container>
